import styled from '@emotion/styled';
import type { CSSObject } from '@emotion/react';

type FlexProps = {
  wrap?: boolean;
  gapX?: boolean;
  gapY?: boolean;
  align?: CSSObject['alignItems'];
  justify?: CSSObject['justifyContent'];
  mb?: boolean;
  ml?: boolean;
  mr?: boolean;
  mt?: boolean;
  mx?: boolean;
  my?: boolean;
};

const Flex = styled.div<FlexProps>`
  display: flex;

  align-items: ${({ align = 'start' }) => align};
  justify-content: ${({ justify = 'start' }) => justify};

  margin-bottom: ${({ mb = false }) => mb && '1rem'};
  margin-top: ${({ mt = false }) => mt && '1rem'};

  margin-left: ${({ ml = false }) => ml && '1rem'};
  margin-right: ${({ mr = false }) => mr && '1rem'};

  margin-top: ${({ my = false }) => my && '1rem'};
  margin-bottom: ${({ my = false }) => my && '1rem'};

  margin-left: ${({ mx = false }) => mx && '1rem'};
  margin-right: ${({ mx = false }) => mx && '1rem'};

  ${({ gapX = true }) => gapX && 'grid-column-gap: 0.5rem;'}
  ${({ gapY = false }) => gapY && 'grid-row-gap: 0.5rem;'}
    
  @media (min-width: 567px) {
    ${({ wrap = false }) => wrap && 'flex-wrap: wrap;'}
  }
`;

export default Flex;
